"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPropertyLabelComponent = DefaultPropertyLabelComponent;
const react_1 = __importDefault(require("react"));
function DefaultPropertyLabelComponent({ selectorIsValid, selectorIsHidden, selectorLabel, translatePropertyLabelHover, propertyName }) {
    return (react_1.default.createElement("label", { className: !selectorIsValid ? "invalid" : undefined, title: translatePropertyLabelHover(propertyName) },
        react_1.default.createElement("span", { className: selectorIsHidden ? "hidden-property" : "" }, selectorLabel)));
}
//# sourceMappingURL=default-property-label-component.js.map